import axios from "axios";
import { PARTNER_ID } from '../general/global_variables'

export const MEDIA_PATH = "https://partner.ens.edu.br/"

const api = axios.create({
    baseURL: "https://partner.ens.edu.br/api/",
});

export default api;


export function getPageContent(){
    return api.get(`pagecontent/${PARTNER_ID}`)
}

export function getSocialMedias(){
    return api.get(`social-medias/`)
}

export function getOffers(){
    return api.get(`courses/${PARTNER_ID}`)
}

export function getCategories(){
    return api.get(`categories/${PARTNER_ID}`)
}